import EN_TRANSLATION from './en.json';
import ES_TRANSLATION from './es.json';
import PT_TRANSLATION from './pt.json';
import { initI18n } from '../Translate';
import { Languages } from '../Translate.domain';

initI18n({
  debug: true,
  resources: {
    en: {
      translation: EN_TRANSLATION,
    },
    pt: {
      translation: PT_TRANSLATION,
    },
    es: {
      translation: ES_TRANSLATION,
    },
  },
  lng: Languages.EN,
  fallbackLng: Languages.EN,
});

console.log('i18next initialized with resources:', Languages.EN);
